export const calculateAllowSorting = (editType, formatType: string) => {
	if (formatType === 'image' || editType === 'actionButton') {
		return false;
	}

	return true;
};
